<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body bg-light">
        <h3>Expediente PLD</h3>
        <p class="text-muted">Información de beneficiarios por sociedad y accionista</p>


        <!-- Society selector -->
        <div class="mb-4">
          <label class="form-label fw-bold">Seleccione una sociedad</label>
          <select class="form-select" style="max-width: 400px;"
                  [(ngModel)]="selectedSocietyRfc"
                  (ngModelChange)="onSocietyChange()">
            <option value="">-- Seleccione --</option>
            <option *ngFor="let s of societies" [value]="s.rfc">
              {{ s.razonSocial }} ({{ s.rfc }})
            </option>
          </select>
        </div>

        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2">Cargando beneficiarios...</p>
        </div>

        <div *ngIf="!loading && selectedSocietyRfc && shareholdersWithBeneficiaries.length === 0" class="alert alert-info">
          No hay accionistas (rol accionista) para esta sociedad; sin ellos no se puede registrar un beneficiario.
        </div>

        <div *ngIf="!loading && selectedSocietyRfc && shareholdersWithBeneficiaries.length > 0" class="table-responsive">
          <h4>{{ selectedSocietyNombre }}</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr class="table-secondary">
                <th colspan="13" class="text-center py-2">{{ selectedSocietyRfc }} - {{ selectedSocietyNombre }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let sh of shareholdersWithBeneficiaries">
                <!-- Shareholder header row -->
                <tr class="table-warning">
                  <td colspan="13" class="py-2">
                    <strong>Accionista:</strong> {{ sh.nombre }} ({{ sh.rfc }})
                    <button class="btn btn-sm btn-primary ms-2" (click)="openAddPdlPerson(sh)" title="Agregar beneficiario">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="bi bi-person-plus">
                        <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
                        <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"/>
                      </svg>
                      Agregar beneficiario
                    </button>
                  </td>
                </tr>
                <!-- Beneficiary header -->
                <tr class="table-light">
                  <th class="text-center">Nombre</th>
                  <th class="text-center">Alias</th>
                  <th class="text-center">Email(s)</th>
                  <th class="text-center">Teléfono(s)</th>
                  <th class="text-center">Familiares</th>
                  <th class="text-center">Fecha de alta</th>
                  <th class="text-center" colspan="7">Otros datos</th>
                </tr>
                <tr *ngIf="sh.beneficiaries.length === 0">
                  <td colspan="13" class="text-muted text-center small py-3">Sin beneficiarios registrados para este accionista.</td>
                </tr>
                <!-- Beneficiary rows -->
                <tr *ngFor="let b of sh.beneficiaries" class="align-top">
                  <td>{{ b.fullName || '-' }}</td>
                  <td>{{ b.alias || '-' }}</td>
                  <td class="small">{{ formatEmails(b) }}</td>
                  <td class="small">{{ formatPhones(b) }}</td>
                  <td class="small">{{ formatRelatives(b) }}</td>
                  <td class="small text-nowrap">{{ b.createdAt ? (b.createdAt | date:'short') : '-' }}</td>
                  <td colspan="7" class="small">
                    <span *ngIf="b.bornDate">Nacimiento: {{ b.bornDate | date:'shortDate' }}</span>
                    <span *ngIf="b.bornCity"> | Ciudad: {{ b.bornCity }}</span>
                    <span *ngIf="b.bornCountry"> | País: {{ b.bornCountry }}</span>
                    <span *ngIf="b.gender"> | Género: {{ b.gender }}</span>
                    <span *ngIf="b.maritalStatus"> | Estado civil: {{ b.maritalStatus }}</span>
                    <span *ngIf="!b.bornDate && !b.bornCity && !b.gender && !b.maritalStatus">-</span>
                    <div class="mt-2">
                      <ng-container *ngIf="(b.identitys || []).length === 0">
                        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openIdentityDocumentModal(b)" title="Ver documento de identidad">
                          Ver documento
                        </button>
                      </ng-container>
                      <ng-container *ngFor="let ident of b.identitys || []">
                        <button type="button" class="btn btn-sm btn-outline-primary me-1 mb-1" (click)="openIdentityDocumentModal(b, ident)" title="Ver {{ ident.identityTypeName || 'documento' }}">
                          {{ ident.identityTypeName || 'Doc' }} {{ ident.idNumber ? '(' + ident.idNumber + ')' : '' }}
                        </button>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Identity document preview modal -->
<ng-template #identityDocumentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ currentIdentityLabel || 'Documento de identidad' }}</h5>
    <div class="d-flex align-items-center gap-2">
      <a *ngIf="documentPreviewUrl" [href]="documentPreviewUrl" [download]="getDownloadFileName()" class="btn btn-sm btn-outline-primary" title="Descargar documento">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="me-1"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
        Descargar
      </a>
      <button type="button" class="btn-close" aria-label="Cerrar" (click)="closeIdentityDocumentModal()"></button>
    </div>
  </div>
  <div class="modal-body border-bottom bg-light py-2" *ngIf="currentIdentityDetails">
    <div class="row small">
      <div class="col-md-6 col-lg-3" *ngIf="currentIdentityDetails.identityTypeName">
        <strong>Tipo:</strong> {{ currentIdentityDetails.identityTypeName }}
      </div>
      <div class="col-md-6 col-lg-3" *ngIf="currentIdentityDetails.idNumber">
        <strong>Número:</strong> {{ currentIdentityDetails.idNumber }}
      </div>
      <div class="col-md-6 col-lg-3" *ngIf="currentIdentityDetails.authority">
        <strong>Autoridad emisora:</strong> {{ currentIdentityDetails.authority }}
      </div>
      <div class="col-md-6 col-lg-3" *ngIf="currentIdentityDetails.country">
        <strong>País:</strong> {{ currentIdentityDetails.country }}
      </div>
      <div class="col-md-6 col-lg-3" *ngIf="currentIdentityDetails.fileName">
        <strong>Archivo:</strong> {{ currentIdentityDetails.fileName }}
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="documentLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Cargando documento...</p>
    </div>
    <div *ngIf="!documentLoading && documentErrorMessage" class="alert alert-warning mb-0">
      {{ documentErrorMessage }}
    </div>
    <div *ngIf="!documentLoading && documentPreviewUrl && !documentErrorMessage" class="document-preview-container">
      <div *ngIf="isPdfContent()" class="document-preview-pdf">
        <span class="badge bg-secondary mb-2">PDF</span>
        <pdf-viewer [src]="documentPreviewUrl" [render-text]="true" style="width: 100%; height: 70vh;"></pdf-viewer>
      </div>
      <div *ngIf="isImageContent()" class="document-preview-image text-center">
        <span class="badge bg-secondary mb-2">{{ getImageTypeLabel() }}</span>
        <div class="overflow-auto" style="max-height: 70vh;">
          <img [src]="documentPreviewUrl" alt="Documento de identidad" class="img-fluid">
        </div>
      </div>
      <div *ngIf="!isPdfContent() && !isImageContent()" class="alert alert-info">
        Tipo de archivo no soportado para vista previa. Formatos válidos: PDF, JPEG, PNG.
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeIdentityDocumentModal()">Cerrar</button>
  </div>
</ng-template>
